<template>
	<AoMapPreview
		v-if="isShowMapsPreview"
		:loading="mapsFlags.isLoadingMapPreview"
		:geojsonData="mapsPreview"
		class="mb-1"
	/>
</template>

<script setup>
import { onMounted } from 'vue'

import AoMapPreview from '@/components/ui/AoMapPreview.vue'

import useMaps from '@/composables/data/useMaps'

const props = defineProps({
	mapInfo: {
		type: Object,
		default: () => (null),
	},
})

const {
	mapsPreview,
	isShowMapsPreview,
	flags: mapsFlags,
	getMapsPreview,
} = useMaps()

onMounted(async () => {
	if (props.mapInfo) await getMapsPreview(props.mapInfo)
})
</script>
